import store from "@/store";
import i18n from "../plugins/i18n";

const error = (error: any) => {
  let message = "";
  if (error?.response) {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      store.getters.appInstance.$router.push({ name: "login" });
    }
    message = error.response.data.message;
  } else {
    message = error.toString();
  }
  store.getters.appInstance?.$notify.error({
    title: String(i18n.global.t("message.ERROR")),
    message: message,
  });
};

const success = (message: string) => {
  store.getters.appInstance.$notify.success({
    title: String(i18n.global.t("message.SUCCESS")),
    message: message,
  });
};

const info = (message: string) => {
  store.getters.appInstance.$notify.info({
    title: String(i18n.global.t("message.INFO")),
    message: message,
  });
};

export default { error, success, info };
 